import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "@/assets/styles/common.scss";
import Repository from "@/repository";

let token = localStorage["userData"] ? JSON.parse(localStorage["userData"])['access'] : null;
if (token) {
  Repository.connector.setAuthHeaders(token)
}

router.beforeEach((to, from, next) => {
  if (!token && to.name !== 'login') {
    next({ name: 'login' });
  }
  else if (token && to.path === '/') {
    next({ name: 'roles' });
  }
  else next()
});

createApp(App).use(store).use(router).mount("#app");
